const asInputString = value =>
  value === null || value === undefined ? '' : String(value);

export const normalizePositiveInteger = value =>
  asInputString(value).replace(/\D/g, '').replace(/^0+/, '');

export const normalizeDecimal = value => {
  const [integerPart = '', ...decimalParts] = asInputString(value).
  replace(/[^\d.]/g, '').split('.');
  const normalizedIntegerPart = integerPart.replace(/^0+(?=\d)/, '');
  return decimalParts.length ?
  `${normalizedIntegerPart}.${decimalParts.join('')}` :
  normalizedIntegerPart;
};

export const normalizedEvent = (event, normalize) => ({
  ...event,
  target: { ...event.target, value: normalize(event.target.value) }
});
